<xpo-card [class]="generateClass(title)">
  <xpo-card-header>
    <xpo-card-title>
      {{ title }}
    </xpo-card-title>
  </xpo-card-header>
    <ng-content></ng-content>
</xpo-card>
